import React, { useContext } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import { Dropdown } from "react-bootstrap";

import DropdownItem from "./DropdownItem";
import EventUserAvailabilityToggle from "../../EventUser/EventUserAvailabilityToggle";
import SoundMuteToggle from "../../players/SoundMuteToggle";
import eventUserAvailabilityStatus from "../../../data/enums/eventUserAvailabilityStatus";
import EventUserProfilePicture from "../../EventUser/EventUserProfilePicture";

import { UserContext } from "../../../contexts/UserContext";

export default function DropdownMenu() {
  const router = useRouter();
  const { event } = router.query;
  const { me } = useContext(UserContext);

  return (
    <>
      <Dropdown className="nav-dropdown">
        <Dropdown.Toggle className="toggle-button toggle-button__with_profile-picture">
          {me && (
            <EventUserProfilePicture eventUser={me} hasAvailability={false} />
          )}
        </Dropdown.Toggle>
        <div className="custom-dropdown">
          <Dropdown.Menu className="custom-dropdown mt-2">
            <DropdownItem label={"Notification Sound"}>
              <SoundMuteToggle />
            </DropdownItem>
            {/* <DropdownItem
              label={"Available for Chat"}
              icon={
                me && me.availability === eventUserAvailabilityStatus.ONLINE ? (
                  <svg viewBox='0 0 512 512'>
                    <path d='M504.502,75.496c-9.997-9.998-26.205-9.998-36.204,0L161.594,382.203L43.702,264.311c-9.997-9.998-26.205-9.997-36.204,0 c-9.998,9.997-9.998,26.205,0,36.203l135.994,135.992c9.994,9.997,26.214,9.99,36.204,0L504.502,111.7 C514.5,101.703,514.499,85.494,504.502,75.496z' />
                  </svg>
                ) : (
                    <svg viewBox='0 0 512 512'>
                      <path d='M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z M51,255c0-112.2,91.8-204,204-204 c45.9,0,89.25,15.3,124.95,43.35l-285.6,285.6C66.3,344.25,51,300.9,51,255z M255,459c-45.9,0-89.25-15.3-124.95-43.35 L415.65,130.05C443.7,165.75,459,209.1,459,255C459,367.2,367.2,459,255,459z' />
                    </svg>
                  )
              }
            >
              <EventUserAvailabilityToggle />
            </DropdownItem> */}
            {/* <Link href="/[event]/check-in?uuid=[uuid]" as={`/${event}/check-in?uuid=${me?.uuid}`}> */}
            <Link href={`/${event}/check-in?uuid=${me?.uuid}`}>
              <span style={{ display: "block" }}>
                <DropdownItem label="Edit Badge">
                  <img
                    className="nav-dropdown-item-icon"
                    src="/assets/badgeIcon.svg"
                  />
                </DropdownItem>
              </span>
            </Link>
            <Link href="/[event]/logout" as={`/${event}/logout`}>
              <span style={{ display: "block" }}>
                <DropdownItem
                  label="Leave this Event"
                  icon={
                    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.3881 7.9354L10.7631 14.2141C10.2131 15.1667 8.98367 15.4961 8.03104 14.9461L4.87005 13.1211C4.4024 12.8511 4.06823 12.4099 3.93347 11.8934L2.52932 6.47541C2.52932 6.47541 3.38241 6.25781 3.40473 6.25915C3.5475 6.23187 3.68941 6.25607 3.81931 6.33107C3.91458 6.38607 3.98618 6.46205 4.03912 6.55035C4.05394 6.56468 5.29041 8.69306 5.29041 8.69306L8.26791 3.53588C8.47541 3.17648 8.93302 3.05386 9.29242 3.26136C9.65182 3.46886 9.77444 3.92648 9.56694 4.28588L7.81694 7.31697L8.24996 7.56697L10.625 3.45335C10.8325 3.09395 11.2901 2.97133 11.6495 3.17883C12.0089 3.38633 12.1315 3.84395 11.924 4.20335L9.54899 8.31697L9.98201 8.56697L12.107 4.88636C12.3145 4.52696 12.7721 4.40435 13.1315 4.61185C13.4909 4.81935 13.6135 5.27696 13.406 5.63636L11.281 9.31697L11.7141 9.56697L13.0891 7.1854C13.2966 6.826 13.7542 6.70338 14.1136 6.91088C14.473 7.11838 14.5956 7.576 14.3881 7.9354Z" />
                    </svg>
                  }
                >
                  <img
                    className="nav-dropdown-item-icon pe-1"
                    src="/assets/signOutIcon.svg"
                  />
                </DropdownItem>
              </span>
            </Link>
          </Dropdown.Menu>
        </div>
      </Dropdown>
    </>
  );
}
